import { 
  createRjPoster as createRjPosterThunk, 
  updateRjPoster as updateRjPosterThunk, 
  deleteRjPoster as deleteRjPosterThunk 
} from '../reducers/rjSlice';

// Action to create RJ poster
export const createRjPoster = (adminData, payload) => {
  return async (dispatch) => {
    try {
      await dispatch(createRjPosterThunk({ adminData, payload }));
    } catch (error) {
      console.error('Error creating RJ poster:', error);
      throw error;
    }
  };
};

// Action to update RJ poster
export const updateRjPoster = (adminData, payload) => {
  return async (dispatch) => {
    try {
      await dispatch(updateRjPosterThunk({ adminData, payload }));
    } catch (error) {
      console.error('Error updating RJ poster:', error);
      throw error;
    }
  };
};

// Action to delete RJ poster
export const deleteRjPoster = (adminData, rjPosterId) => {
  return async (dispatch) => {
    try {
      await dispatch(deleteRjPosterThunk({ adminData, rjPosterId }));
    } catch (error) {
      console.error('Error deleting RJ poster:', error);
      throw error;
    }
  };
};